// ==========================================================================
// YEEZY LIGHTBOX / QUICK VIEW
// - Każdy przycisk (produkt) niesie WŁASNE zdjęcia w atrybucie data-images,
//   więc przełączanie nigdy nie "wycieka" do innych produktów.
// - Nawigacja tylko przez swipe (dotyk) / przeciąganie (mysz) + strzałki
//   klawiatury (dla dostępności) - bez widocznych przycisków strzałek.
// - Jeśli przycisk niesie dane produktu (tytuł/cena/warianty), pokazuje się
//   panel szybkiego zakupu z przyciskiem "Dodaj do koszyka" (AJAX, bez
//   przeładowania strony).
// ==========================================================================
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var lightbox = document.getElementById('yeezy-lightbox');
    if (!lightbox) return;

    var stage = document.getElementById('yeezy-lightbox-stage');
    var lightboxImage = document.getElementById('yeezy-lightbox-image');
    var closeBtn = document.getElementById('yeezy-lightbox-close');
    var dotsWrap = document.getElementById('yeezy-lightbox-dots');
    var infoPanel = document.getElementById('yeezy-lightbox-info');
    var titleEl = document.getElementById('yeezy-lightbox-title');
    var priceEl = document.getElementById('yeezy-lightbox-price');
    var variantSelect = document.getElementById('yeezy-lightbox-variant');
    var addBtn = document.getElementById('yeezy-lightbox-add');
    var viewLink = document.getElementById('yeezy-lightbox-view');

    var currentImages = [];
    var currentIndex = 0;
    var lastFocusedElement = null;

    function showImage(index, skipFade) {
      var item = currentImages[index];
      if (!item) return;

      if (skipFade) {
        lightboxImage.src = item.src;
        lightboxImage.alt = item.alt || '';
      } else {
        lightboxImage.classList.add('is-swapping');
        setTimeout(function () {
          lightboxImage.src = item.src;
          lightboxImage.alt = item.alt || '';
          lightboxImage.classList.remove('is-swapping');
        }, 160);
      }

      updateDots(index);
    }

    function renderDots() {
      dotsWrap.innerHTML = '';
      if (currentImages.length <= 1) return;
      currentImages.forEach(function (_, i) {
        var dot = document.createElement('span');
        dot.className = 'yeezy-lightbox__dot' + (i === currentIndex ? ' is-active' : '');
        dotsWrap.appendChild(dot);
      });
    }

    function updateDots(index) {
      var dots = dotsWrap.querySelectorAll('.yeezy-lightbox__dot');
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function populateInfo(trigger) {
      var title = trigger.getAttribute('data-title');

      if (!title) {
        infoPanel.hidden = true;
        lightbox.classList.remove('has-info');
        return;
      }

      infoPanel.hidden = false;
      lightbox.classList.add('has-info');
      titleEl.textContent = title;
      priceEl.textContent = trigger.getAttribute('data-price') || '';
      viewLink.href = trigger.getAttribute('data-product-url') || '#';

      var variants = [];
      try {
        variants = JSON.parse(trigger.getAttribute('data-variants') || '[]');
      } catch (e) {
        variants = [];
      }

      variantSelect.innerHTML = '';
      if (variants.length > 1) {
        variantSelect.hidden = false;
        variants.forEach(function (variant) {
          var option = document.createElement('option');
          option.value = variant.id;
          option.textContent = variant.title + (variant.available ? '' : ' — wyprzedane');
          if (!variant.available) option.disabled = true;
          variantSelect.appendChild(option);
        });
      } else {
        variantSelect.hidden = true;
      }

      addBtn.disabled = false;
      addBtn.textContent = 'Dodaj do koszyka';
      addBtn.dataset.singleVariantId = variants.length ? variants[0].id : '';
    }

    function openLightbox(trigger) {
      try {
        currentImages = JSON.parse(trigger.getAttribute('data-images') || '[]');
      } catch (e) {
        currentImages = [];
      }
      currentIndex = parseInt(trigger.getAttribute('data-start-index') || '0', 10) || 0;

      lastFocusedElement = trigger;
      showImage(currentIndex, true);
      renderDots();
      populateInfo(trigger);

      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('yeezy-lightbox-open');
      closeBtn.focus();
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('yeezy-lightbox-open');
      lightboxImage.src = '';
      if (lastFocusedElement) lastFocusedElement.focus();
    }

    function showPrev() {
      if (currentImages.length < 2) return;
      currentIndex = (currentIndex - 1 + currentImages.length) % currentImages.length;
      showImage(currentIndex);
    }

    function showNext() {
      if (currentImages.length < 2) return;
      currentIndex = (currentIndex + 1) % currentImages.length;
      showImage(currentIndex);
    }

    // Otwieranie (delegacja zdarzeń - działa też dla treści doładowanych dynamicznie)
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-yeezy-lightbox-trigger]');
      if (!trigger) return;
      event.preventDefault();
      openLightbox(trigger);
    });

    closeBtn.addEventListener('click', closeLightbox);

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', function (event) {
      if (!lightbox.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') showPrev();
      if (event.key === 'ArrowRight') showNext();
    });

    // Swipe (dotyk) / przeciąganie (mysz) zamiast strzałek
    var dragStartX = 0;
    var dragCurrentX = 0;
    var isDragging = false;
    var DRAG_THRESHOLD = 50;

    function getPointerX(event) {
      return event.touches ? event.touches[0].clientX : event.clientX;
    }

    function dragStart(event) {
      if (event.target.closest('button, select, a')) return;
      isDragging = true;
      dragStartX = getPointerX(event);
      dragCurrentX = dragStartX;
    }

    function dragMove(event) {
      if (!isDragging) return;
      dragCurrentX = getPointerX(event);
    }

    function dragEnd() {
      if (!isDragging) return;
      isDragging = false;
      var delta = dragCurrentX - dragStartX;
      if (delta > DRAG_THRESHOLD) {
        showPrev();
      } else if (delta < -DRAG_THRESHOLD) {
        showNext();
      }
    }

    stage.addEventListener('touchstart', dragStart, { passive: true });
    stage.addEventListener('touchmove', dragMove, { passive: true });
    stage.addEventListener('touchend', dragEnd);

    stage.addEventListener('mousedown', dragStart);
    window.addEventListener('mousemove', dragMove);
    window.addEventListener('mouseup', dragEnd);

    // Dodawanie do koszyka bez przeładowania strony (Shopify AJAX Cart API)
    addBtn.addEventListener('click', function () {
      var variantId = variantSelect.hidden ? addBtn.dataset.singleVariantId : variantSelect.value;
      if (!variantId) return;

      addBtn.disabled = true;
      addBtn.textContent = 'Dodawanie...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add-to-cart-failed');
          return fetch('/cart.js');
        })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var cartCountEl = document.querySelector('[data-yeezy-cart-count]');
          if (cartCountEl) cartCountEl.textContent = cart.item_count;

          addBtn.textContent = 'Dodano ✓';
          setTimeout(function () {
            addBtn.textContent = 'Dodaj do koszyka';
            addBtn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          addBtn.textContent = 'Błąd — spróbuj ponownie';
          addBtn.disabled = false;
        });
    });
  });
})();